import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { InstructorBase } from './../../../../Layouts/Instructor/V2/InstructorBase'
import { Loading } from './../../../../Common/Loading'

import { LogErrors } from './../../../../../utilities/LogErrors'
import { ValidateSession } from './../../../../../utilities/BL/Sessions'
import { useFloatMessage, MESSAGE_TYPE } from './../../../../Providers/FloatMessage'
import { GetLicensesSummary } from './../../../../../utilities/BL/Instructor/Licenses'
import { WEBPAGES } from './../../../../../utilities/EL/WebPages'
import { ROLES } from './../../../../../utilities/EL/Roles'


const Licenses = () => {
    const navigate = useNavigate()
    const { showMessage } = useFloatMessage()

    const [isLoading, setIsLoading] = useState(true)
    const [licensesSummary, setLicensesSummary] = useState({
        assigned: 0,
        used: 0,
        remaining: 0
    })

    useEffect(() => {
        async function ValidateAndLoad() {
            try {
                const tmpSession = await ValidateSession()

                if (tmpSession.success) {
                    const resSummary = await GetLicensesSummary()
                    if (resSummary.success) {
                        setLicensesSummary(resSummary.data)
                    } else {
                        showMessage({ type: MESSAGE_TYPE.BAD, text: resSummary.message || 'No fue posible cargar el resumen de licencias.' })
                    }
                    setIsLoading(false)
                } else {
                    navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
                }
            } catch (error) {
                await LogErrors('ValidateAndLoad - Instructor Licenses', error)
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        ValidateAndLoad()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate])

    return isLoading ? (
        <Loading />
    ) : (
        <InstructorBase urlToGo={'/dashboard'} page={WEBPAGES.INSTRUCTOR.DASHBOARD} role={ROLES.INSTRUCTOR}>
            <section className='container Instructor__Instructors'>
                <p className='Instructor__Title Instructor__Title--Center'>Licencias Ztudia</p>

                <div className='container mt-5 Tables--Shadow Tables--Background p-4' style={{ maxWidth: '600px', borderRadius: '15px' }}>
                    <p className='Instructor__Subtitle Instructor__Subtitle--Center mb-4 border-bottom pb-2 fw-bold text-uppercase' style={{ letterSpacing: '0.05em' }}>
                        Resumen de Licencias
                    </p>

                    <div className='d-flex flex-column gap-3 px-3 py-2'>
                        <div className='d-flex align-items-center border-bottom pb-2'>
                            <span className='Instructor__Text--Bold fs-5 flex-grow-1 text-nowrap'>Licencias Asignadas:</span>
                            <span className='Instructor__Text fs-5 text-end' style={{ width: '70px' }}>{licensesSummary.assigned}</span>
                            <span style={{ width: '170px' }}></span>
                        </div>
                        <div className='d-flex align-items-center border-bottom pb-2'>
                            <span className='Instructor__Text--Bold fs-5 flex-grow-1 text-nowrap'>Licencias Utilizadas:</span>
                            <span className='Instructor__Text fs-5 text-end' style={{ width: '70px' }}>{licensesSummary.used}</span>
                            <span className='d-flex justify-content-end' style={{ width: '170px' }}>
                                <button
                                    type='button'
                                    className='Btn__Ztudia--PrimaryOutline'
                                    style={{ width: 'auto', padding: '9.9px 20px', margin: 0 }}
                                    onClick={() => navigate('/instructor/licenses/used')}
                                >
                                    Detalles
                                </button>
                            </span>
                        </div>
                        <div className='d-flex align-items-center pb-2'>
                            <span className='Instructor__Text--Bold fs-5 flex-grow-1 text-nowrap'>Licencias Restantes:</span>
                            <span className='Instructor__Text fs-5 fw-bold text-success text-end' style={{ width: '70px' }}>{licensesSummary.remaining}</span>
                            <span style={{ width: '170px' }}></span>
                        </div>
                    </div>
                </div>
            </section>
        </InstructorBase>
    )
}

export { Licenses };
